import TaskNameDataAccuracy from "../../../../components/AssetManagement/Health/DataAccuracy/TaskNameDataAccuracy/TaskNameDataAccuracy";
import { useEffect } from "react";
import {
  selectUserData,
  selectUserToken,
} from "../../../../features/userSlice";
import { useSelector } from "react-redux";
import { DataAccuracyEndPointLogic } from "../../../../logic/AssetManagement/Health/Data Accuracy/dataAccuracyEndPointLogic";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import DataAccuracyFullSkeleton from "./DataAccuracyFullSkeleton";
import { setTasksByTaskStructureSharedUidLoader } from "../../../../features/dataAccuracySlice";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Page404 from "../../../../components/Page404/Page403";
import FloatingActionItems from "../../../FloatingItems/FloatingActionItems";
const TaskNameDataAccruracyScreen = () => {
  const token = useSelector(selectUserToken);
  const [searchParams] = useSearchParams();
  const taskStructureSharedUid = searchParams.get("task_structure_shared_uid");
  const assetSharedUid = searchParams.get("asset_shared_uids")?.split(",");
  const response = useSelector(selectUserData);
  const dispatch = useDispatch();
  const { tasksByTaskStructureSharedUidLoader, isSuccess } = useSelector(
    (state: any) => state.dataAccuracy
  );
  const queryId = "5637377896742912";
  const fetchBy = searchParams.get("fetchBy") || "Website";
  const type = fetchBy === "Website" ? "site" : "dimension";
  const selectedSites = searchParams.get("selected")?.split(",");
  const siteAndDimensionsList = useSelector(selectUserData);
  const dimensionList = siteAndDimensionsList?.data?.dimensions;
  const siteList = siteAndDimensionsList?.data?.website_permissions;
  const { allDimensions } = useSelector((state: any) => state.dataAccuracy);
  const userPermittedOrganizationName =
    siteAndDimensionsList?.data?.user_details?.organization_name;
  const allDimenssionList = allDimensions.filter(
    (dimension: any) =>
      dimension.organization_id__organization_name ===
      userPermittedOrganizationName
  );

  const filteredDimensionList = allDimenssionList.map((dimension: any) => {
    return dimension.dimension;
  });

  const initialSelected = searchParams.get("selected")?.split(",") || [];

  const hasEditDataAnomalyPermission = CheckPermissions(
    response?.data?.products?.assets,
    "health",
    "edit_data_anomaly"
  );

  useEffect(() => {
    const fetchDataAccuracy = async () => {
      dispatch(setTasksByTaskStructureSharedUidLoader(true));
      try {
        await DataAccuracyEndPointLogic.getTasksByTaskStructureSharedUid(
          token,
          taskStructureSharedUid ?? "",
          assetSharedUid,
          dispatch
        );
        await DataAccuracyEndPointLogic.getDataAccuracyByWebsiteOrDimensionOrOrganization(
          queryId,
          token,
          type,
          type === "site" ? selectedSites : [Object.keys(siteList[0])[0]],
          fetchBy === "Dimension"
            ? selectedSites
            : fetchBy === "Organization"
            ? filteredDimensionList // Send all dimensions for Organization
            : [dimensionList[0]],
          dispatch
        );
        await DataAccuracyEndPointLogic.getAllUserList(token);
      } catch (error) {
        dispatch({ type: "error", payload: { message: error } });
      } finally {
        dispatch(setTasksByTaskStructureSharedUidLoader(false));
      }
    };
    if (hasEditDataAnomalyPermission) {
      fetchDataAccuracy();
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchDataAccuracy = async () => {
      dispatch(setTasksByTaskStructureSharedUidLoader(true));
      try {
        await DataAccuracyEndPointLogic.getTasksByTaskStructureSharedUid(
          token,
          taskStructureSharedUid ?? "",
          assetSharedUid,
          dispatch
        );
        await DataAccuracyEndPointLogic.getDataAccuracyByWebsiteOrDimensionOrOrganization(
          queryId,
          token,
          type,
          type === "site" ? selectedSites : [Object.keys(siteList[0])[0]],
          fetchBy === "Dimension"
            ? selectedSites
            : fetchBy === "Organization"
            ? filteredDimensionList // Send all dimensions for Organization
            : [dimensionList[0]],
          dispatch
        );
        await DataAccuracyEndPointLogic.getAllUserList(token);
      } catch (error) {
        dispatch({ type: "error", payload: { message: error } });
      } finally {
        dispatch(setTasksByTaskStructureSharedUidLoader(false));
      }
    };
    if (hasEditDataAnomalyPermission && isSuccess) {
      fetchDataAccuracy();
    }

    // eslint-disable-next-line
  }, [isSuccess]);

  return (
    <>
      {!hasEditDataAnomalyPermission ? (
        <Page404 />
      ) : tasksByTaskStructureSharedUidLoader ? (
        <DataAccuracyFullSkeleton />
      ) : (
        <>
          <TaskNameDataAccuracy />
          {initialSelected?.length > 0 ? (
            <div data-tracker="514">
              <FloatingActionItems
                selectedSiteFloatingAction={initialSelected[0]}
                selectedDimensionsFloatingAction={""}
                trackIdFloatingAction={"515"}
              />
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default TaskNameDataAccruracyScreen;
